import Navbar from "./Components/Navbar/Navbar";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Shop from './Pages/Shop';
import ShopCategory from './Pages/ShopCategory';
import Product from './Pages/Product';

import Footer from '../src/Components/Footer/Footer';
import React from "react";
import Cart from "./Pages/Cart";
import Order from "./Pages/Order";
import OrderSummary from "./Components/OrderSummary/OrderSummary";

// import men_banner from './Components/Assets/banner_mens.png';
// import women_banner from './Components/Assets/banner_women.png';
// import kids_banner from './Components/Assets/banner_kids.png';

import './App.css';

function App() {
  return (
    <div>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Shop />} />
          {/* <Route path="/men" element={<ShopCategory banner={men_banner} category="men" />} /> */}
          {/* <Route path="/women" element={<ShopCategory banner={women_banner} category="women" />} /> */}
          {/* <Route path="/kids" element={<ShopCategory banner={kids_banner} category="kid" />} /> */}
          
       
          <Route path="/product/:productId" element={<Product />} />
          
          <Route path="/cart" element={<Cart />} />
          <Route path="/order" element={<Order/>}/>
          <Route path="/order-summary" element = {<OrderSummary/>}/>

        </Routes>
        <Footer />
        {/* WhatsApp Icon Button */}
        <div className="whatsapp-icon">
          <a href="https://wa.me/+923203218800" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-whatsapp"></i>
          </a>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
